(function () {
  'use strict';
  // State
  // Each key is a step; value is an ARRAY of selected items.
  // e.g. { tee: [{variantId, title, image, price, size, step}, ...], hat: [...] }
  const state = {};
  let pendingItem = null; // item waiting for size selection
  let bundleSize = 3;
  let discountPct = 20;
  // Step icon SVGs for progress indicators
  const STEP_ICONS = {
    tee: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.57a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.57a2 2 0 0 0-1.34-2.23z"/></svg>`,
    hat: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h20M4 20V10l8-7 8 7v10"/></svg>`,
    gift: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>`,
  };
  // Init
  function init() {
    // 1. Clear abandoned checkout items asynchronously if user returned from checkout
    const pendingItems = sessionStorage.getItem('bundle_pending_items');
    if (pendingItems) {
      sessionStorage.removeItem('bundle_pending_items');
      try {
        const updates = {};
        JSON.parse(pendingItems).forEach(id => { updates[id] = 0; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).catch(err => console.error('[BundleBuilder] Cart cleanup failed:', err));
      } catch (e) {}
    }

    // 2. Standard initialization
    const section = document.querySelector('.bundle-builder');
    if (!section) return;
    if (window.location.hash) history.replaceState(null, '', window.location.pathname + window.location.search);
    bundleSize = parseInt(section.dataset.bundleSize, 10) || 3;
    discountPct = parseInt(section.dataset.discount, 10) || 20;
    
    bindAddButtons();
    bindPlusButtons();
    bindFilterTabs();
    bindSidebarRemove();
    bindCartButton();
    bindSizeModal();
    bindModalInteraction();
    bindMobileDrawer();
    bindCategoryNav();
    startTimer();
    renderSidebar();
  }
  // Countdown Timer
    function startTimer() {
    const timerEl = document.getElementById('SidebarTimer');
    const countdownEl = document.getElementById('SidebarCountdown');
    if (!timerEl || !countdownEl) return;

    const endDateStr = timerEl.dataset.endDate;
    if (!endDateStr || endDateStr.trim() === '') {
      timerEl.style.display = 'none';
      return;
    }

    const endDateObj = new Date(endDateStr);
    if (isNaN(endDateObj.getTime())) {
      timerEl.style.display = 'none';
      return;
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    let secondsLeft = (endDateObj.getTime() - Date.now()) / 1000;

    function updateCountdown() {
      if (secondsLeft <= 0) {
        countdownEl.textContent = '00 : 00 : 00 : 00';
        return;
      }
      secondsLeft -= 1;
      const days  = pad(Math.floor(secondsLeft / 86400));
      const hours = pad(Math.floor((secondsLeft % 86400) / 3600));
      const mins  = pad(Math.floor((secondsLeft % 3600) / 60));
      const secs  = pad(Math.floor(secondsLeft % 60));
      countdownEl.textContent = `${days} : ${hours} : ${mins} : ${secs}`;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
  // Left Category Nav — updates badge count and red border on selection
  function updateCategoryNav() {
    const steps = getSteps();
    steps.forEach((step) => {
      const circle = document.getElementById(`CategoryNavCircle-${step}`);
      const count = (state[step] || []).length;
      if (circle) {
        circle.classList.toggle('is-active', count > 0);
      }
    });
  }
  function bindCategoryNav() {
    document.querySelectorAll('.category-nav__item').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = link.getAttribute('href');
        if (target) {
          document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }
  // Filter Tabs
  function bindFilterTabs() {
    document.querySelectorAll('.filter-tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        document
          .querySelectorAll('.filter-tab')
          .forEach((t) => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        filterGrid(tab.dataset.filter);
      });
    });
  }
  function filterGrid(filter) {
    document.querySelectorAll('.bundle-card').forEach((card) => {
      const show = filter === 'all' || card.dataset.category === filter;
      card.style.display = show ? '' : 'none';
    });
  }
  // ADD Buttons
  function bindAddButtons() {
    document.querySelectorAll('.bundle-card__add-btn').forEach((btn) => {
      btn.addEventListener('click', () => handleAdd(btn));
    });
  }
  function handleAdd(btn) {
    const step = btn.dataset.step;
    const hasSizes = btn.dataset.hasSizes === 'true';
    const variants = JSON.parse(btn.dataset.variants || '[]');
    // Support for Seal Subscriptions Selling Plans
    let sellingPlans = [];
    if (btn.dataset.sellingPlans) {
      try { sellingPlans = JSON.parse(btn.dataset.sellingPlans); } catch (e) {}
    }
    const item = {
      step,
      title: btn.dataset.title,
      image: btn.dataset.image,
      price: parseInt(btn.dataset.price, 10),
      variantId: variants[0]?.id,
      size: null,
      sellingPlans,
    };
    if (hasSizes && variants.length > 1) {
      pendingItem = item;
      openSizeModal(variants, item);
    } else {
      item.variantId = variants[0]?.id;
      commitItem(item);
    }
  }
  /**
   * Add an item to the step's array.
   * Duplicate variantIds within the same step are allowed so the shopper
   * can buy multiples of the same product.
   */
  function commitItem(item) {
    if (!state[item.step]) {
      state[item.step] = [];
    }
    // Only allow 1 of each product per step
    const alreadyAdded = state[item.step].some((existing) => existing.title === item.title);
    if (alreadyAdded) return;
    state[item.step].push(item);
    renderSidebar();
    updateCardStates();
  }
  // Plus Icon Buttons
  function bindPlusButtons() {
    document.querySelectorAll('.bundle-card__plus-btn, .bundle-card__plus-icon, .js-open-quickview').forEach((btn) => {
      btn.addEventListener('click', () => handlePlusClick(btn));
    });
  }
  function handlePlusClick(btn) {
    const rawTarget = btn.dataset.target || btn.dataset.modalId;
    if (!rawTarget) return;
    const modalId = rawTarget.replace('#', '');
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }
  }
  // Modal Interaction
  function bindModalInteraction() {
    document.querySelectorAll('.bundle-modal').forEach((modal) => {
      const backdrop = modal.querySelector('[data-modal-close], .bundle-modal__backdrop');
      const closeBtn = modal.querySelector('.bundle-modal__close');
      const addBtn = modal.querySelector('.js-modal-add-btn, .js-quickview-add, .bundle-modal__submit');
      if (backdrop) {
        backdrop.addEventListener('click', () => closeModal(modal));
      }
      if (closeBtn) {
        closeBtn.addEventListener('click', () => closeModal(modal));
      }
      if (addBtn) {
        addBtn.addEventListener('click', () => handleModalAdd(modal, addBtn));
      }
      // Unlock button on variant selection safely
      const radios = modal.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (addBtn) addBtn.disabled = false;
        });
      });
      bindCarouselControls(modal);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal(modal);
        }
      });
    });
  }
  function bindCarouselControls(modal) {
    const prevBtn = modal.querySelector('.carousel-btn--prev');
    const nextBtn = modal.querySelector('.carousel-btn--next');
    const dots = modal.querySelectorAll('.carousel-dot');
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const carouselId = prevBtn.dataset.carouselId;
        slideCarousel(carouselId, -1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const carouselId = nextBtn.dataset.carouselId;
        slideCarousel(carouselId, 1);
      });
    }
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const slideIndex = parseInt(dot.dataset.slide, 10);
        const carousel = modal.querySelector('.bundle-modal__carousel');
        const track = carousel?.querySelector('.carousel-track');
        if (track) {
          track.style.transform = `translateX(-${slideIndex * 100}%)`;
          updateCarouselDots(modal, slideIndex);
        }
      });
    });
  }
  function slideCarousel(carouselId, direction) {
    const carousel = document.getElementById(carouselId);
    if (!carousel) return;
    const track = carousel.querySelector('.carousel-track');
    const slides = carousel.querySelectorAll('.carousel-slide');
    if (!track || slides.length === 0) return;
    const transform = track.style.transform || 'translateX(0%)';
    const match = transform.match(/-?\d+/);
    let currentPos = match ? Math.abs(parseInt(match[0], 10)) : 0;
    let slideIndex = currentPos / 100;
    slideIndex += direction;
    if (slideIndex < 0) slideIndex = slides.length - 1;
    if (slideIndex >= slides.length) slideIndex = 0;
    track.style.transform = `translateX(-${slideIndex * 100}%)`;
    updateCarouselDots(carousel.parentElement, slideIndex);
  }
  function updateCarouselDots(modal, activeIndex) {
    const dots = modal.querySelectorAll('.carousel-dot');
    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === activeIndex);
    });
  }
  function closeModal(modal) {
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
  }
  function handleModalAdd(modal, btn) {
    if (btn.disabled || btn.textContent.trim() === 'SOLD OUT' || btn.textContent.trim() === 'LIMIT REACHED') {
      return; 
    }
    const step = btn.dataset.step || modal.id.split('-')[1];
    const title = btn.dataset.title;
    const image = btn.dataset.image;
    let price = btn.dataset.price ? parseInt(btn.dataset.price, 10) : 0;
    const selectedRadios = Array.from(modal.querySelectorAll('input[type="radio"]:checked'));
    let variantId = btn.dataset.variant ? parseInt(btn.dataset.variant, 10) : null;
    let size = null;
    if (selectedRadios.length > 0) {
      const variantJson = modal.querySelector('script[type="application/json"]');
      if (variantJson) {
        try {
          const variants = JSON.parse(variantJson.textContent);
          const selectedValues = selectedRadios.map((r) => r.value.toLowerCase().trim());
          const matchedVariant = variants.find((v) => {
            const vOpts = [v.option1, v.option2, v.option3].filter(Boolean).map((o) => o.toLowerCase().trim());
            return selectedValues.every((val) => vOpts.includes(val));
          });
          if (matchedVariant) {
            if (!matchedVariant.available) {
              btn.textContent = 'SOLD OUT';
              btn.disabled = true;
              return;
            }
            
            variantId = matchedVariant.id;
            price = matchedVariant.price;
            size = selectedRadios.map((r) => r.value).join(' / ');
          } else if (variants[0]) {
            variantId = variants[0].id;
          }
        } catch (e) {
          console.warn('Failed to parse variants:', e);
        }
      }
    }
    if (!variantId && btn.dataset.variant) {
      variantId = parseInt(btn.dataset.variant, 10);
    }
    if (!variantId) {
      console.warn('[BundleBuilder] Could not resolve variant ID.');
      return;
    }
    let sellingPlans = [];
    if (btn.dataset.sellingPlans) {
      try { sellingPlans = JSON.parse(btn.dataset.sellingPlans); } catch (e) {}
    }
    const item = { step, title, image, price, variantId, size, sellingPlans };
    commitItem(item);
    closeModal(modal);
  }
  // Card States
  /* A card is marked selected if at least one of its variants is present anywhere in the step's item array. */
  function updateCardStates() {
    const totalItems = getAllItems().length;
    const isFull = totalItems >= bundleSize;
    // Update Main Grid Buttons
    document.querySelectorAll('.bundle-card').forEach((card) => {
      const step = card.dataset.step;
      const btn = card.querySelector('.bundle-card__add-btn');
      if (!btn) return;
      const variants = JSON.parse(btn.dataset.variants || '[]');
      const variantIds = new Set(variants.map((v) => v.id));
      const stepItems = state[step] || [];
      const isSelected = stepItems.some((item) => variantIds.has(item.variantId));
      card.classList.toggle('is-selected', isSelected);
      // If this step already has a selection, disable ALL cards in that step
      const stepHasSelection = stepItems.length > 0;
      btn.disabled = isFull || stepHasSelection;
    });
    // Update Modal Submit Buttons (Quickview/Popups)
    document.querySelectorAll('.bundle-modal').forEach((modal) => {
      const modalAddBtn = modal.querySelector('.js-modal-add-btn, .js-quickview-add, .bundle-modal__submit');
      if (modalAddBtn) {
        const step = modalAddBtn.dataset.step;
        const stepItems = state[step] || [];
        const stepHasSelection = stepItems.length > 0;
        // Keep text as 'ADD TO BUNDLE', only toggle disabled
        modalAddBtn.disabled = isFull || stepHasSelection;
      }
    });
  }
  // Size Modal
  function openSizeModal(variants, item) {
    const modal = document.getElementById('SizeModal');
    const options = document.getElementById('SizeModalOptions');
    if (!modal || !options) return;
    const isFull = getAllItems().length >= bundleSize;
    options.innerHTML = '';
    
    // Track unique sizes so we don't accidentally print "S" multiple times
    const seenSizes = new Set();
    variants.forEach((variant) => {
      // Shopify titles are often "Color / Size", e.g. "Olive Ash / S". We only want the "S"!
      let cleanTitle = variant.title;
      if (cleanTitle.includes('/')) {
        cleanTitle = cleanTitle.split('/').pop().trim();
      }
      
      if (seenSizes.has(cleanTitle)) return;
      seenSizes.add(cleanTitle);
      const btn = document.createElement('button');
      btn.className = 'size-option';
      btn.textContent = cleanTitle;
      
      // Disable if product is out of stock OR if bundle is full
      btn.disabled = !variant.available || isFull;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (getAllItems().length >= bundleSize) return; 
        pendingItem.variantId = variant.id;
        pendingItem.size = cleanTitle;
        commitItem(pendingItem);
        pendingItem = null;
        closeSizeModal();
      });
      options.appendChild(btn);
    });
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeSizeModal() {
    const modal = document.getElementById('SizeModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    pendingItem = null;
  }
  function bindSizeModal() {
    document.getElementById('SizeModalCancel')?.addEventListener('click', closeSizeModal);
    document.getElementById('SizeModalBackdrop')?.addEventListener('click', closeSizeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSizeModal();
    });
  }
  // Sidebar Render
  function bindSubscriptionToggle() {
    const toggle = document.getElementById('SubscribeToggle');
    const freqBox = document.getElementById('SubscriptionFrequencies');
    if (toggle && freqBox) {
      freqBox.style.display = toggle.checked ? 'block' : 'none';
      toggle.addEventListener('change', (e) => {
        freqBox.style.display = e.target.checked ? 'block' : 'none';
        renderSidebar();
      });
    }
  }
  function bindMobileDrawer() {
    const toggleArea = document.querySelector('.js-mobile-drawer-toggle');
    const sidebar = document.getElementById('BundleSidebar');
    if (toggleArea && sidebar) {
      toggleArea.addEventListener('click', () => {
        sidebar.classList.toggle('is-expanded');
      });
    }
  }
  function renderSidebar() {
    renderProgress();
    renderItems();
    renderTotals();
    updateCartButton();
    updateUnlockedMessage();
    updateCategoryNav();
  }
  
  function updateUnlockedMessage() {
    const msg = document.getElementById('SidebarUnlockedMsg');
    if (!msg) return;
    const hasTee = (state['tee'] && state['tee'].length > 0);
    const hasHat = (state['hat'] && state['hat'].length > 0);
    
    if (hasTee && hasHat) {
      msg.style.display = 'block';
    } else {
      msg.style.display = 'none';
    }
  }
  
  /**
   * Renders progress: updates the "X/3" fraction text and the step icon buttons.
   */
  function renderProgress() {
    const steps = getSteps();
    const totalSteps = steps.length || bundleSize;
    const filledCount = steps.filter(s => (state[s] || []).length > 0).length;
    // Update fraction text
    const fractionEl = document.getElementById('SidebarProgressFraction');
    if (fractionEl) {
      fractionEl.textContent = `${filledCount}/${totalSteps}`;
    }
    // Update step icon buttons
    const iconsEl = document.getElementById('SidebarProgress');
    if (!iconsEl) return;
    iconsEl.innerHTML = steps.map(step => {
      const isFilled = (state[step] || []).length > 0;
      const icon = STEP_ICONS[step] || '';
      return `<span class="sidebar-progress-icon${isFilled ? ' filled' : ''}" title="${step}">${icon}</span>`;
    }).join('');
  }
  /**
   * Renders slot-based item list.
   * Each step gets a slot row.
   * Empty slot → placeholder. Filled → item detail with remove button.
   */
  function renderItems() {
    const list = document.getElementById('SidebarItemsList');
    if (!list) return;
    const steps = getSteps();
    list.innerHTML = '';
    steps.forEach((step) => {
      const items = state[step] || [];
      const categoryName = getCategoryName(step);
      const slot = document.createElement('div');
      slot.className = 'sidebar-slot';
      if (items.length === 0) {
        // Empty placeholder
        slot.innerHTML = `
          <div class="sidebar-slot__empty">
            <span class="sidebar-slot__plus">+</span>
            <span class="sidebar-slot__label">Select ${categoryName}</span>
          </div>
        `;
        slot.querySelector('.sidebar-slot__empty').addEventListener('click', () => {
          document.getElementById(`BundleCategory-${step}`)?.scrollIntoView({ behavior: 'smooth' });
        });
      } else {
        // Render the first (and only) selected item for this step
        const item = items[0];
        slot.innerHTML = `
          <div class="sidebar-item">
            <div class="sidebar-item__img-wrap">
              <img src="${escHtml(item.image)}" alt="${escHtml(item.title)}">
              <button
                class="sidebar-item__remove"
                aria-label="Remove ${escHtml(item.title)}"
                data-step="${escHtml(step)}"
                data-index="0"
              >&#215;</button>
            </div>
            <div class="sidebar-item__info">
              <p class="sidebar-item__step">${escHtml(step.toUpperCase())}</p>
              <p class="sidebar-item__name">${escHtml(item.title)}</p>
              ${item.size ? `<p class="sidebar-item__size">Size: ${escHtml(item.size)}</p>` : ''}
            </div>
          </div>
        `;
        slot.querySelector('.sidebar-item__remove')?.addEventListener('click', (e) => {
          const s = e.currentTarget.dataset.step;
          const i = parseInt(e.currentTarget.dataset.index, 10);
          if (state[s]) {
            state[s].splice(i, 1);
            if (state[s].length === 0) delete state[s];
          }
          renderSidebar();
          updateCardStates();
        });
      }
      list.appendChild(slot);
    });
  }
  /**
   * Reads the human-readable category name for a step from the DOM heading,
   * stripping the "CHOOSE YOUR " prefix. Falls back to sensible defaults.
   */
  function getCategoryName(step) {
    const el = document.querySelector(`#BundleCategory-${step} .bundle-category-heading`);
    if (el) {
      return el.textContent.replace(/^CHOOSE YOUR\s+/i, '').trim();
    }
    const defaults = { tee: 'Graphic Tee', hat: 'Trucker Hat', gift: 'Free Accessories' };
    return defaults[step] || step.charAt(0).toUpperCase() + step.slice(1);
  }
  function renderTotals() {
    const el = document.getElementById('SidebarTotals');
    if (el) el.classList.add('is-visible');
  }
  /**
   * Enable the cart button once every category 1 item selected.
   */
  function updateCartButton() {
    const btn = document.getElementById('AddBundleToCart');
    if (!btn) return;
    const steps = getSteps();
    const allStepsFilled = steps.length > 0 && steps.every(step => (state[step] || []).length > 0);
    btn.disabled = !allStepsFilled;
  }
  // Cart Submission
  function bindCartButton() {
    document.getElementById('AddBundleToCart')?.addEventListener('click', addToCart);
  }
  async function addToCart() {
    const btn = document.getElementById('AddBundleToCart');
    const allItems = getAllItems();
    const steps = getSteps();
    const allStepsFilled = steps.length > 0 && steps.every(step => (state[step] || []).length > 0);
    if (!allStepsFilled) return;
    
    const items = allItems.map(({ item }) => ({
      id: parseInt(item.variantId, 10),
      quantity: 1,
    }));

    // Track variants in session storage to clear them if user hits the back button
    sessionStorage.setItem('bundle_pending_items', JSON.stringify(items.map(i => i.id)));

    btn.disabled = true;
    btn.textContent = 'Adding…';
    btn.classList.add('is-loading');
    
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`Cart error ${res.status}`);
      window.location.href = '/checkout?discount=BUNDLE';
    } catch (err) {
      console.error('[BundleBuilder] addToCart failed:', err);
      sessionStorage.removeItem('bundle_pending_items'); // Clear tracking on failure
      btn.disabled = false;
      btn.textContent = 'Error — Try Again';
      btn.classList.remove('is-loading');
    }
  }
  function bindSidebarRemove() {
    // Delegated to renderItems
  }
  // Helpers
  function getSteps() {
    const keys = new Set();
    document.querySelectorAll('.bundle-card').forEach((c) => {
      if (c.dataset.step) keys.add(c.dataset.step);
    });
    return [...keys];
  }
  /**
   * Returns a flat list of all selected items across every step,
   * each entry shaped as { item, step, index } where index is the
   * position within that step's array (used for targeted removal).
   */
  function getAllItems() {
    const result = [];
    for (const step of Object.keys(state)) {
      (state[step] || []).forEach((item, index) => {
        result.push({ item, step, index });
      });
    }
    return result;
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle Back/Forward Cache & Navigation precisely
  window.addEventListener('pageshow', function(e) {
    const navEntries = performance.getEntriesByType("navigation");
    const navType = navEntries.length > 0 ? navEntries[0].type : '';
    
    if (e.persisted || navType === "back_forward") {
      window.location.reload();
    }
  });
})();